var _defineProperty = require("/data/var/lib/jenkins/workspace/AFM-Portal-Prod-CustomerEngage_AccountManagement_warfilebuild/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

module.exports = function (modules) {
  var installedModules = {};

  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: !1,
      exports: {}
    };
    return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
  }

  return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function (exports, name, getter) {
    __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
      enumerable: !0,
      get: getter
    });
  }, __webpack_require__.r = function (exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, __webpack_require__.t = function (value, mode) {
    if (1 & mode && (value = __webpack_require__(value)), 8 & mode) return value;
    if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
    var ns = Object.create(null);
    if (__webpack_require__.r(ns), Object.defineProperty(ns, "default", {
      enumerable: !0,
      value: value
    }), 2 & mode && "string" != typeof value) for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    return ns;
  }, __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function () {
      return module.default;
    } : function () {
      return module;
    };
    return __webpack_require__.d(getter, "a", getter), getter;
  }, __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = "./index.ts");
}({
  "../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js": function node_modulesBabelRuntimeCorejs3CoreJsObjectDefinePropertyJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/define-property");
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js": function node_modulesBabelRuntimeCorejs3HelpersClassCallCheckJs(module, exports) {
    module.exports = function (instance, Constructor) {
      if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/createClass.js": function node_modulesBabelRuntimeCorejs3HelpersCreateClassJs(module, exports, __webpack_require__) {
    var _Object$defineProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js");

    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), _Object$defineProperty(target, descriptor.key, descriptor);
      }
    }

    module.exports = function (Constructor, protoProps, staticProps) {
      return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/defineProperty.js": function node_modulesBabelRuntimeCorejs3HelpersDefinePropertyJs(module, exports, __webpack_require__) {
    var _Object$defineProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js");

    module.exports = function (obj, key, value) {
      return key in obj ? _Object$defineProperty(obj, key, {
        value: value,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : obj[key] = value, obj;
    };
  },
  "./index.ts": function indexTs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, "Logger", function () {
      return Logger_Logger;
    }), __webpack_require__.d(__webpack_exports__, "log", function () {
      return log;
    }), __webpack_require__.d(__webpack_exports__, "trace", function () {
      return trace;
    }), __webpack_require__.d(__webpack_exports__, "debug", function () {
      return debug;
    }), __webpack_require__.d(__webpack_exports__, "info", function () {
      return info;
    }), __webpack_require__.d(__webpack_exports__, "warning", function () {
      return warning;
    }), __webpack_require__.d(__webpack_exports__, "error", function () {
      return error;
    }), __webpack_require__.d(__webpack_exports__, "makeUniqueWarningLog", function () {
      return makeUniqueWarningLog;
    });

    var classCallCheck = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js"),
        classCallCheck_default = __webpack_require__.n(classCallCheck),
        createClass = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/createClass.js"),
        createClass_default = __webpack_require__.n(createClass),
        defineProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/defineProperty.js"),
        defineProperty_default = __webpack_require__.n(defineProperty),
        external_loglevel_ = __webpack_require__("loglevel"),
        external_loglevel_plugin_prefix_ = __webpack_require__("loglevel-plugin-prefix"),
        external_loglevel_plugin_prefix_default = __webpack_require__.n(external_loglevel_plugin_prefix_),
        config_ = __webpack_require__("@jutro/config");

    var DEFAULT_LOGGER_CONFIG = {
      level: Object(config_.getConfigValue)("JUTRO_LOGGER_LEVEL", "WARN"),
      prefixTemplate: "%l:",
      loggerName: "jutro-logger"
    };

    var Logger_Logger = function () {
      function Logger(loggerConfig) {
        classCallCheck_default()(this, Logger), defineProperty_default()(this, "log", void 0);
        var config = loggerConfig || DEFAULT_LOGGER_CONFIG;
        this.setConfig(config);
      }

      return createClass_default()(Logger, [{
        key: "setConfig",
        value: function value(config, replace) {
          var configs = replace ? config : _objectSpread({}, DEFAULT_LOGGER_CONFIG, {}, config),
              level = configs.level,
              prefixTemplate = configs.prefixTemplate,
              loggerName = configs.loggerName;
          external_loglevel_plugin_prefix_default.a.reg(external_loglevel_), external_loglevel_plugin_prefix_default.a.apply(external_loglevel_, {
            template: prefixTemplate
          }), this.log = external_loglevel_.getLogger(loggerName), this.log.setLevel(level);
        }
      }, {
        key: "resetConfig",
        value: function value() {
          this.setConfig(DEFAULT_LOGGER_CONFIG);
        }
      }, {
        key: "trace",
        value: function value(message) {
          this.log.trace(message);
        }
      }, {
        key: "debug",
        value: function value(message) {
          this.log.debug(message);
        }
      }, {
        key: "info",
        value: function value(message) {
          this.log.info(message);
        }
      }, {
        key: "warning",
        value: function value(message, options) {
          options && options.bold ? this.log.warn("%c" + message, "font-weight: bold") : this.log.warn(message);
        }
      }, {
        key: "error",
        value: function value(message) {
          this.log.error(message);
        }
      }]), Logger;
    }();

    var log = new Logger_Logger(),
        trace = function trace(message) {
      log.trace(message);
    },
        debug = function debug(message) {
      log.debug(message);
    },
        info = function info(message) {
      log.info(message);
    },
        warning = function warning(message, options) {
      log.warning(message, options);
    },
        error = function error(message) {
      log.error(message);
    },
        makeUniqueWarningLog = function makeUniqueWarningLog(message) {
      return function (messageFunction) {
        var called = !1;
        return function (message) {
          called || (called = !0, messageFunction(message));
        };
      }(function () {
        return warning(message);
      });
    };
  },
  "@jutro/config": function jutroConfig(module, exports) {
    module.exports = require("@jutro/config");
  },
  "core-js-pure/features/object/define-property": function coreJsPureFeaturesObjectDefineProperty(module, exports) {
    module.exports = require("core-js-pure/features/object/define-property");
  },
  loglevel: function loglevel(module, exports) {
    module.exports = require("loglevel");
  },
  "loglevel-plugin-prefix": function loglevelPluginPrefix(module, exports) {
    module.exports = require("loglevel-plugin-prefix");
  }
});